/**
 * Signup API Service
 *
 * Provides typed wrappers around the signup flow endpoints.
 * Uses the same httpClient as login (works without auth token for public endpoints).
 */

import { httpClient } from './http-client.service';
import type {
  SignupInitiateRequest,
  SignupInitiateResponse,
  SignupResendOTPRequest,
  SignupResendOTPResponse,
  SignupVerifyOTPRequest,
  SignupVerifyOTPResponse,
} from '../types/signup';

class SignupAPIService {
  /**
   * Initiate signup flow - sends OTP to user's email
   * POST /signup/initiate
   */
  async initiateSignup(data: SignupInitiateRequest): Promise<SignupInitiateResponse> {
    const response = await httpClient.post<SignupInitiateResponse>('signup/initiate', data);
    return response.data;
  }

  /**
   * Resend OTP to user's email
   * POST /signup/otp/resend
   */
  async resendOTP(data: SignupResendOTPRequest): Promise<SignupResendOTPResponse> {
    const response = await httpClient.post<SignupResendOTPResponse>('signup/otp/resend', data);
    return response.data;
  }

  /**
   * Verify OTP and create pending user account
   * POST /signup/otp/verify
   */
  async verifyOTP(data: SignupVerifyOTPRequest): Promise<SignupVerifyOTPResponse> {
    const response = await httpClient.post<SignupVerifyOTPResponse>('signup/otp/verify', data);
    return response.data;
  }
}

export const signupAPI = new SignupAPIService();
export { SignupAPIService };
